module.exports = __webpack_public_path__ + "static/media/richard.61a4e0f5.jpg";